<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-container v-if="courseinfo!=null" class="card2">
            <v-card class="box" flat>
                <div class="text-center">
                    <v-btn class="ma-2 button4"  @click="viewQuesBank1()">View Question Bank</v-btn>
                    <v-btn  class="ma-2 button1" @click="viewTemplate">Subject Template View</v-btn>
                    <v-btn class="ma-2 button2"  @click="qbankSummary">
                        Approve And Submit Question Paper
                        <template v-slot:loader>
                            <span>Loading...</span>
                        </template>
                    </v-btn>
                </div>
                <div class="text-center">
                    <v-chip class="ma-2" color="success" outlined>
                        <strong>{{courseinfo.crscode}}:{{courseinfo.crsname}}</strong>
                    </v-chip>

                    <v-chip class="ma-2" color="primary" outlined pill>
                        <strong>Question Type</strong>

                        :: {{qttype.name}}
                    </v-chip>

                    <v-chip class="ma-2" color="deep-purple accent-4" outlined>
                        <strong>Exam Type : {{examtype.name}}</strong>
                    </v-chip>
                </div>
                <!-- <v-bottom-navigation class="bottom">
                    <v-btn value="recent" v-for="uq in unitwisequestion" :key="uq.id">
                        <span>Question Count :{{uq.count}}</span>
                        <span>Unit Number : {{uq.unit}}</span>
                    </v-btn>
                </v-bottom-navigation> -->
                <br />
            </v-card>
            <v-card class="box" flat>
                <v-row justify="center">
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-autocomplete :items="unit_list" item-text="name" item-value="id" label="Select Unit" v-model="editedItem.unit" :error="errorMsg.unit?true:false" :error-messages="errorMsg.unit?'Required':''"></v-autocomplete>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-autocomplete
                            :items="diff_level_list"
                            item-text="name"
                            item-value="id"
                            v-model="editedItem.difficultylevel"
                            label="Select Difficulty Level"
                            :error="errorMsg.unit?true:false"
                            :error-messages="errorMsg.unit?'Required':''"
                        ></v-autocomplete>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4">
                        <v-text-field v-model.trim="co_code" label="Co Code"></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <span  class="slide">*NOTE:Question And Option Image File size Should be less than 200kb And It Should be in JPEG Format!!!</span>
            <v-card class="box" flat>
                <center class="card-text"><strong>Question</strong></center>
                <v-row>
                <v-col cols="12" sm="8" md="8">
                        <ckeditor v-model="question" :config="editorConfig"></ckeditor>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-row>
                        <v-col cols="12" sm="9" >
                            <v-file-input v-model="qfile" accept="image/jpeg, image/jpg" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                        </v-col>
                        <!-- <v-col cols="12" sm="4">
                            <v-select :items="marks_list" label="Marks" v-model.trim="weightage" item-value="id" item-text="marks" required></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" class="span-mr">
                            <v-checkbox v-model="isapprove" class="mx-2" label="Approve"></v-checkbox>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        
                    </v-row> -->
                </v-col>
                </v-row>
            </v-card>
              <v-card class="box" flat>
                     <v-alert class="alert" v-if="this.flag1==true" dismissible outlined type="error">
                    Image size should be less than 200KB!
                    </v-alert>
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            <v-card-subtitle class="pb-0">Option A:</v-card-subtitle>
                        </v-col>

                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="option_01" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-row>
                                <v-col cols="12">
                                    <v-file-input accept="image/jpeg, image/jpg" v-model="optfile1" prepend-icon="mdi-attachment" label="Choose File" id="file1" show-size name="doc"></v-file-input>
                                </v-col>
                                <v-col cols="12">
                                    <input type="radio" class="radiospace" id="a" value="a" v-model="iscorrect_01" />
                                    <label for="a">Correct Answer</label>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="box" flat>
                     <v-alert class="alert" v-if="this.flag2==true" dismissible outlined type="error">
                        Image size should be less than 200KB!
                        </v-alert>
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            <v-card-subtitle class="pb-0">Option B:</v-card-subtitle>
                        </v-col>

                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="option_02" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-row>
                                <v-col cols="12">
                                    <v-file-input v-model="optfile2" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" id="file2" label="Choose File" show-size name="doc"></v-file-input>
                                </v-col>
                                <v-col cols="12">
                                    <input type="radio" class="radiospace" id="b" value="b" v-model="iscorrect_01" />
                                    <label for="b">Correct Answer</label>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
                <div id="c" style="display: none;">
                    <v-card class="box" flat>
                         <v-alert class="alert" v-if="this.flag3==true" dismissible outlined type="error">
                        Image size should be less than 200KB!
                        </v-alert>
                        <v-row>
                            <v-col cols="12" sm="2" md="2">
                                <v-card-subtitle class="pb-1">Option C:</v-card-subtitle>
                                <!-- <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip> -->
                            </v-col>

                            <v-col cols="12" sm="7" md="7">
                                <ckeditor v-model="option_03" :config="editorConfig"></ckeditor>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input v-model="optfile3" accept="image/jpeg, image/jpg" prepend-icon="mdi-attachment" label="Choose File" id="file3" show-size name="doc"></v-file-input>
                                    </v-col>
                                    <v-col cols="12">
                                        <input type="radio" class="radiospace" id="c" value="c" v-model="iscorrect_01" />
                                        <label for="c">Correct Answer</label>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-btn  style="display" class="button btn-submit-align" id="optiond" :loading="loader" @click="enableOptionD()">Add Option</v-btn>
                </div>
                <div id="d" style="display: none;">
                    <v-card class="box" flat>
                         <v-alert class="alert" v-if="this.flag4==true" dismissible outlined type="error">
                        Image size should be less than 200KB!
                        </v-alert>
                        <v-row>
                            <v-col cols="12" sm="2" md="2">
                                <v-card-subtitle class="pb-1">Option D:</v-card-subtitle>
                                <!-- <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small ><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip> -->
                            </v-col>

                            <v-col cols="12" sm="7" md="7">
                                <ckeditor v-model="option_04"  :config="editorConfig"></ckeditor>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input v-model="optfile4" id="file4" prepend-icon="mdi-attachment" accept="image/jpeg, image/jpg" label="Choose File" show-size name="doc"></v-file-input>
                                    </v-col>
                                    <v-col cols="12">
                                        <input type="radio" class="radiospace" id="d" value="d" v-model="iscorrect_01" />
                                        <label for="d">Correct Answer</label>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-btn style="display" class="button btn-submit-align" id="optione" :loading="loader" @click="enableOptionE()">Add Option</v-btn>
                </div>
                <div id="e" style="display: none;">
                    <v-card class="box" flat>
                         <v-alert class="alert" v-if="this.flag5==true" dismissible outlined type="error">
                        Image size should be less than 200KB!
                        </v-alert>
                        <v-row>
                            <v-col cols="12" sm="2" md="2">
                                <v-card-subtitle class="pb-1">Option E:</v-card-subtitle>
                                <!-- <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" class="mx-2 button-cancel" fab small ><v-icon dark>mdi-close</v-icon></v-btn>
                                        </template>
                                        <span>
                                            Remove
                                        </span>
                                    </v-tooltip> -->
                            </v-col>

                            <v-col cols="12" sm="7" md="7">
                                <ckeditor v-model="option_05" :config="editorConfig"></ckeditor>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input v-model="optfile5" accept="image/jpeg, image/jpg" id="file5" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                    </v-col>
                                    <v-col cols="12">
                                        <input type="radio" class="radiospace" id="e" value="e" v-model="iscorrect_01" />
                                        <label for="e">Correct Answer</label>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <v-card-actions>
                    <v-btn class="button btn-submit-align" style="display" id="option" :loading="loader" @click="enableOptionC()">Add Option</v-btn>
                    <v-row justify="center">
                        <v-btn class="button" @click="savequestion">Save</v-btn>
                    </v-row>
                   
                </v-card-actions>
        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        </v-container>
        <v-dialog v-model="dialog3" max-width="700px">
            <v-card>
                <v-row justify="center" class="heading">
                  <strong>Template :: {{tempname}}</strong>
                </v-row>
                    <span v-if="level_templates==null">
                        Template Information Not Available
                    </span>
                    <span v-if="level_templates!=null">
                       <!-- <v-row justify="center">
                        <strong>Total Marks : {{total_marks}} Total Question : {{total_no_of_questions}}</strong>
                      </v-row> -->
                       <v-col cols="12" sm="12" md="12">
                        <v-row >
                            <v-col cols="12" sm="9" md="9">
                                 <strong>Total Marks : {{total_marks}} </strong>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <strong> Total Question : {{total_no_of_questions}} </strong>
                           </v-col>
                        </v-row> 
                   </v-col>
                        <v-col v-for="templates in level_templates" :key="templates.level">
                            <v-card class="card">
                                <v-card-text>
                                    <center class="heading">
                                        <h3>
                                            {{templates.level}}
                                            <span class="opacity">Marks:{{templates.weightage}}</span>
                                        </h3>
                                    </center>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Unit</th>
                                                    <th class="text-left"># of ques</th>
                                                    <th class="text-left"># of ques picked</th>
                                                    <th class="text-left">weightage</th>
                                                    <th class="text-left">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in templates.templates" :key="item.id">
                                                    <td>{{ item.unit }}</td>
                                                    <td>{{ item.numberofquestionsinbank }}</td>
                                                    <td>{{ item.numberofrandomquestionstobepicked }}</td>
                                                    <td>{{ item.weightagetoeachquestion }}</td>
                                                    <td>{{ item.totalmarks }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </span>
                <v-card-actions>
                  <v-row justify="center">
                    <v-btn class="button-cancel" @click="dialog3 = false">Close</v-btn>
                  </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog4" max-width="1000px">
            <v-card>
                  <v-row justify="center" class="heading">
                    <strong>Template :: {{tempname2}}</strong>
                    <span v-if="level_templates==null">
                        Template Information Not Available
                    </span>
                  </v-row>
                    <template v-if="level_templates!=null">
                        <v-col cols="12" sm="12" md="12">
                        <v-row >
                            <v-col cols="12" sm="9" md="9">
                                 <strong>Total Marks : {{total_marks}} </strong>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <strong> Total Question : {{total_no_of_questions}} </strong>
                           </v-col>
                        </v-row> 
                   </v-col>
                        <center>
                          <v-col v-for="templates in level_templates" :key="templates.level">
                            <v-card class="card">
                                <v-card-text>
                                  <center class="heading">
                                    <h3>
                                        {{templates.level}}
                                        <span class="opacity">Marks : {{templates.weightage}}</span>
                                    </h3>
                                    </center>
                                    <center>
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Unit</th>
                                                        <th class="text-left"># of ques</th>
                                                        <th class="text-left"># of ques picked</th>
                                                        <th class="text-left"># Your Question count</th>
                                                        <th class="text-left"># Approve Question count</th>
                                                        <th class="text-left"># Unapprove Question count</th>
                                                        <th class="text-left"># Is Verified Question count</th>
                                                        <th class="text-left">weightage</th>
                                                        <th class="text-left">Total</th>
                                                        <th class="text-left">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in templates.templates" :key="item.id">
                                                        <td>{{ item.unit }}</td>
                                                        <td>{{ item.numberofquestionsinbank }}</td>
                                                        <td>{{ item.numberofrandomquestionstobepicked }}</td>
                                                        <td><center>{{ item.insquestioncount }}</center>
                                                        </td>
                                                        <td>
                                                           <center>{{item.insquestioncount_approve}}</center>
                                                        </td>
                                                        <td>
                                                           <center> {{item.insquestioncount_unapprove}}</center>
                                                        </td>
                                                        <td>
                                                            <center> {{item.isverifiedcount}}</center>
                                                        </td>
                                                        <td>{{ item.weightagetoeachquestion }}</td>
                                                        <td>{{ item.totalmarks }}</td>
                                                        <td v-if="item.unitqstatus == 'true'"><span class="spancolor"><strong>Complete</strong></span> </td>
                                                        <td v-else>
                                                            <span class="spancolor2"><strong>In Progress </strong></span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </center>
                                </v-card-text>
                            </v-card>
                          </v-col>
                        </center>
                    </template>
                <v-card-actions>
                  <v-row justify="center">
                    <v-btn class="button-cancel mr-2" @click="dialog4 = false">Close</v-btn>
                    <v-btn v-if="this.btnon=='1'" class="button" @click="approveQuestionbank">Approve Question Paper</v-btn>
                  </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            errorMsg: {
                unit: false,
                questiontype: false,
                difficultylevel: false,
            },
            editorConfig: {
                // The configuration of the editor.
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib:
                    // "http://cdn.mathjax.org/mathjax/2.6-latest/MathJax.js?config=TeX-AMS_HTML"
                    "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            snackbar_msg: "",
            //vrushali data
            marks_list: [
                { id: 1, marks: "1" },
                { id: 2, marks: "2" },
                { id: 3, marks: "3" },
                { id: 4, marks: "4" },
                { id: 5, marks: "5" },
                { id: 6, marks: "6" },
                { id: 7, marks: "7" },
                { id: 8, marks: "8" },
                { id: 9, marks: "9" },
                { id: 10, marks: "10" },
            ],
            loader: false,
            flag:null,
            flag1:null,
            flag2:null,
            flag3:null,
            flag4:null,
            flag5:null,
            valid: false,
            dialog_upload: false,
            quiztypeid: null,
            question_list: null,
            option_list: null,
            current_course: null,
            c_id: null,
            qno: null,
            img_url: null,
            course: null,
            dialog_zooimg: false,
            dialog_save: false,
            dialog_save_option: false,
            editedIndex: -1,
            id: null,
            dialog_alert:null,
            course_name: null,
            course_code: null,
            quiztype: null,
            question: null,
            iscorrect_01: null,
            optfile1: null,
            optfile2: null,
            optfile3: null,
            optfile4: null,
            optfile5: null,
            option_01: null,
            option_02: null,
            option_03: null,
            option_04: null,
            option_05: null,
            qfile: null,
            isapprove: true,
            weightage: 1,
            option_list: null,
            quiztypeid:null,
            co_code:null,
    
            unitwisequestion: null,
            level_templates: null,
            template_name: null,
            templatename: null,
            total_marks: 0,
            btnon: "",
            total_no_of_questions: 0,
            dialog3: false,
            dialog4: false,
            color: "",
            snackbar: false,
            search: "",
            qno: "",
            load: false,
            dialog: false,
            question_list: null,
            unit_list: null,
            diff_level_list: null,
            courseinfo: null,
            examtype: null,
            qttype: null,
            qfile: null,
            course_id: "",
            ext_flag:false,
            ext_flag1:false,
            ext_flag2:false,
            ext_flag3:false,
            ext_flag4:false,
            ext_flag5:false,
            tempname2:null,
            tempname:null,
            questionflag:null,
            questionfileflag:null,

            editedIndex: -1,
            editedItem: {
                id: "",
                unit: null,
                questiontype: "",
                difficultylevel: null,
                question: "",
                qno: "",
                weightage: "",
                isactive: true,

             
            },
       
        }),


        watch: {
            dialog(val) {
                val || this.close();
            },
            level_templates() {
                if (this.level_templates != null) {
                    this.total_marks = 0;
                    this.total_no_of_questions = 0;
                    for (var i = 0; i < this.level_templates.length; i++) {
                        this.total_marks += parseFloat(this.level_templates[i].weightage);
                        this.total_no_of_questions += parseInt(this.level_templates[i].questions);
                    }
                }
            },
           
        },
        mounted() {
            this.onLoad()
        },

        methods: {
            validateFile() {
                this.ext_flag = false
               if (this.qfile != null) {
                let file = this.qfile;
                let file_name = this.qfile.name;
                //console.log("file_name"+file_name)
                let ext = file_name.split(".").pop();
                //console.log("ext: "+ext)
                    if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        //console.log("ext 2 : "+ext)
                        if (file.size > 200000) {
                            // console.log("file.size: "+file.size)
                            // console.log("854 inside if")
                            this.qfile = "";
                            this.flag=true
                            this.ext_flag = true
                            return false
                        } else{
                            this.ext_flag == false
                            // console.log("859 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },
            validateFileTypeOpt01() {
                this.ext_flag1 = false
                if (this.optfile1 != null) {
                    let file = this.optfile1;
                  //  console.log("Opt01 file : "+file)
                    let file_name = this.optfile1.name;
                    // console.log("Opt01 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt01 ext 2 : "+ext)
                        if (file.size > 200000) {
                            // console.log("Opt01 file.size: "+file.size)
                            // console.log("Opt01 889 inside if")
                            this.optfile1 = "";
                            //this.flag=true
                            this.ext_flag1 = true
                            return false
                        } else{
                            this.ext_flag1 == false
                            // console.log("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            validateFileTypeOpt02() {
                this.ext_flag2 = false
                if (this.optfile2 != null) {
                    let file = this.optfile2;
                   // console.log("Opt02 file : "+file)
                    let file_name = this.optfile2.name;
                    // console.log("Opt01 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                    if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt01 ext 2 : "+ext)
                        if (file.size > 200000) {
                            // console.log("Opt01 file.size: "+file.size)
                            // console.log("Opt01 889 inside if")
                            this.optfile2 = "";
                            //this.flag=true
                            this.ext_flag2 = true
                            return false
                        } else{
                            this.ext_flag2 == false
                            // console.log("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            validateFileTypeOpt03() {
                this.ext_flag3 = false
                if (this.optfile3 != null) {
                    let file = this.optfile3;
                  //  console.log("Opt03 file : "+file)
                    let file_name = this.optfile3.name;
                    // console.log("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            // console.log("Opt01 file.size: "+file.size)
                            // console.log("Opt01 889 inside if")
                            this.optfile3 = "";
                            //this.flag=true
                            this.ext_flag3 = true
                            return false
                        } else{
                            this.ext_flag3 == false
                            // console.log("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            validateFileTypeOpt04() {
                this.ext_flag4 = false
                if (this.optfile4 != null) {
                    let file = this.optfile4;
                   // console.log("Opt04 file : "+file)
                    let file_name = this.optfile4.name;
                    // console.log("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            // console.log("Opt01 file.size: "+file.size)
                            // console.log("Opt01 889 inside if")
                            this.optfile4 = "";
                            //this.flag=true
                            this.ext_flag4 = true
                            return false
                        } else{
                            this.ext_flag4 == false
                            // console.log("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            validateFileTypeOpt05() {
                this.ext_flag5 = false
                if (this.optfile5 != null) {
                    let file = this.optfile5;
                   // console.log("Opt05 file : "+file)
                    let file_name = this.optfile5.name;
                    // console.log("Opt03 file_name : "+file_name)
                    let ext = file_name.split(".").pop();
                     if (ext == "jpeg" || ext == "jpg" || ext == "JPEG" || ext == "JPG") {
                        // console.log("Opt03 ext 3 : "+ext)
                        if (file.size > 200000) {
                            // console.log("Opt01 file.size: "+file.size)
                            // console.log("Opt01 889 inside if")
                            this.optfile5 = "";
                            //this.flag=true
                            this.ext_flag5 = true
                            return false
                        } else{
                            this.ext_flag5 == false
                            // console.log("Opt01 896 inside else")
                            return true;
                        }
                    } else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            // close1() {
            //     var opt = document.getElementById("c");
            //     opt.style.display = "none";
            //     this.option_03 = null
            //     this.optfile3 = null
            //     var opt = document.getElementById("option");
            //     opt.style.display = "block";
            // },
            // close2() {
            //     var opt = document.getElementById("d");
            //     opt.style.display = "none";
            //     this.option_04 = null
            //     this.optfile4 = null
            //     var opt = document.getElementById("optiond");
            //     opt.style.display = "block";
           
            // },
            // close3() {
            //     var opt = document.getElementById("e");
            //     opt.style.display = "none";
            //     this.option_05 = null
            //     this.optfile5 = null
            //     var opt = document.getElementById("optione");
            //     opt.style.display = "block";
            // },
            enablebutton() {
                var optd = document.getElementById("optiond");
                var opte = document.getElementById("optione");
                optd.style.display = "none";
                opte.style.display = "none";
            },
            enableOptionC() {
                var opt = document.getElementById("option");
                var optd = document.getElementById("optiond");
                var opte = document.getElementById("optione");
                opt.style.display = "none";
                optd.style.display = "block";
                opte.style.display = "none";
                var opc = document.getElementById("c");
                opc.style.display = "block";
            },
            enableOptionD() {
                var opt = document.getElementById("option");
                var optd = document.getElementById("optiond");
                var opte = document.getElementById("optione");
                opt.style.display = "none";
                optd.style.display = "none";
                opte.style.display = "block";
                var opd = document.getElementById("d");
                opd.style.display = "block";
            },
            enableOptionE() {
                var opt = document.getElementById("option");
                var optd = document.getElementById("optiond");
                var opte = document.getElementById("optione");
                opt.style.display = "none";
                optd.style.display = "none";
                opte.style.display = "none";
                var ope = document.getElementById("e");
                ope.style.display = "block";
            },
            initializeErrorMsgFalse() {
                this.errorMsg.unit = false;
                this.errorMsg.questiontype = false;
                this.errorMsg.difficultylevel = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
           
            viewTemplate() {
               // alert("in alert")
                const data = {
                    crs_id: this.$store.getters.courseid,
                    qtypeid: this.$store.getters.qbankquestype,
                    questypeid: this.$store.getters.questype,
                };
                axios
                    .post("/Qbank/viewTemplate", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.dialog3 = true;
                            this.level_templates = res.data.level_templates;
                            this.templatename = res.data.templateName;
                            this.tempname = res.data.tempname
                           // alert("tempname::"+res.data.tempname)
                          //  console(res.data.templateName)
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            qbankSummary() {
                const data = {
                    crs_id: this.$store.getters.courseid,
                    qtypeid: this.$store.getters.qbankquestype,
                    questypeid: this.$store.getters.questype,
                };
                axios
                    .post("/Qbank/viewQbankSummmary", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.dialog4 = true;
                            this.level_templates = res.data.level_templates;
                            this.templatename = res.data.templateName;
                            this.btnon = res.data.btnon;
                            this.tempname2 = res.data.tempname
                           // alert(res.data.tempname)
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            approveQuestionbank() {
                const data = {
                    crs_id: this.$store.getters.courseid,
                    qtypeid: this.$store.getters.qbankquestype,
                    questypeid: this.$store.getters.questype,
                };
                axios
                    .post("/Qbank/approveQbank", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.dialog4 = false), this.showSnackbar("#4caf50", "Question Bank Approved Successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            viewQuesBank() {
                this.$router.push("/instructor-question-view");
            },
            viewQuesBank1()
            {
                this.$router.push("/inst-question-view");
            },
            close() {
                this.dialog = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

        
            onLoad(){
                const data = {
                crs_id: this.$store.getters.courseid,
                qtypeid: this.$store.getters.qbankquestype,
                questypeid: this.$store.getters.questype,
                mess: "test",
            };
            axios
                .post("/Qbank/addQuestion", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.courseinfo = res.data.crsinfo;
                        this.question_list = res.data.question_list;
                        this.unit_list = res.data.unitno;
                        this.diff_level_list = res.data.difficultylevel;
                        this.qttype = res.data.questionType;
                        this.qno = res.data.qno;
                        (this.examtype = res.data.examType), (this.unitwisequestion = res.data.unit_question);
                        this.load = true;
                        this.ext_flag = false
                        this.ext_flag1 = false
                        this.ext_flag2 = false
                        this.ext_flag3 = false
                        this.ext_flag4 = false
                        this.ext_flag5 = false
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
            },

savequestion() {
if(this.validateFile()){
    if(this.validateFileTypeOpt01()){
        if(this.validateFileTypeOpt02()){
            if(this.validateFileTypeOpt03()){
            if(this.validateFileTypeOpt04()){
                if(this.validateFileTypeOpt05()){
                let formData = new FormData();
                formData.append("current_course", this.courseinfo.crsid);
                formData.append("qfile", this.qfile);
                formData.append("optfile1", this.optfile1);
                 formData.append("qno", this.qno);
                formData.append("optfile2", this.optfile2);
                formData.append("optfile3", this.optfile3);
                formData.append("qtype", this.qttype.id);
                formData.append("unitid", this.editedItem.unit);
                formData.append("difficultyid", this.editedItem.difficultylevel);
                formData.append("optfile4", this.optfile4);
                formData.append("optfile5", this.optfile5);
                formData.append("weightage", this.weightage);
                formData.append("question", this.question);
                formData.append("isapprove", this.isapprove);
                formData.append("co_code", this.co_code);
                if(this.option_01)
                {
                     formData.append("option_01", this.option_01);
                }
               
                if(this.option_02)
                {
                    formData.append("option_02", this.option_02);
                }
                
                if(this.option_03){
                formData.append("option_03", this.option_03);
                }
               
                if(this.option_04){
                formData.append("option_04", this.option_04);
                }
                
                 if(this.option_05){
                formData.append("option_05", this.option_05);
                 }
                 
                formData.append("iscorrect_01", this.iscorrect_01);
                 if(this.iscorrect_01 == null)
                {  
                    this.showSnackbar("#b71c1c", " Please Select Correct Option!!!"); // show snackbar on error
                    return
                }
                 if(this.editedItem.unit == null)
                {  
                    this.showSnackbar("#b71c1c", " Please Select Unit!!!"); // show snackbar on error
                    return
                }
                 if(this.editedItem.difficultylevel == null)
                {  
                    this.showSnackbar("#b71c1c", " Please Select Difficulty Level !!!"); // show snackbar on error
                    return
                }

                if(this.question == ""){
                    this.questionflag=true;
                }else{
                    this.questionflag=false;
                }

                if(this.qfile==null || this.qfile==""){
                    this.questionfileflag=true;
                }else{
                    this.questionfileflag=false;
                }

                if(this.questionfileflag && this.questionflag)
                {
                
                    this.showSnackbar("#b71c1c", " Please Add Question or File !!!"); // show snackbar on error
                    return
                }
               
                // if(this.qfile == null && this.question == "")
                // {
                
                //     this.showSnackbar("#b71c1c", " Please Add The Question-------- !!!"); // show snackbar on error
                //     return
                // }
                if(this.optfile1 == null && this.option_01 == "")
                {
                
                    this.showSnackbar("#b71c1c", " Please Add The Option 1 !!!"); // show snackbar on error
                    return
                }
                if(this.optfile2 == null && this.option_02 == "")
                {
                
                    this.showSnackbar("#b71c1c", " Please Add The Option 2 !!!"); // show snackbar on error
                    return
                }
                this.dialog_upload = true;
                axios
                    .post("/Qbank/saveQuestionBank", formData, {})
                    .then((res) => {

                         if (res.data.flag == "YES") {
                           this.showSnackbar("#4caf50", " Question Added Successfully..."); // show snackbar on success
                            this.refresh();
                            this.dialog_upload = false;
                            this.onLoad();
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", " Something went wrong..."); // show snackbar on error
                          this.dialog_upload = false;
                    })
                    .finally(() => {
                        this.question=null,
                        this.iscorrect_01=null,
                        this.optfile1=null,
                        this.optfile2=null,
                        this.optfile3=null,
                        this.optfile4=null,
                        this.optfile5=null,
                        this.option_01=null,
                        this.option_02=null,
                        this.option_03=null,
                        this.option_04=null,
                        this.option_05=null,
                        this.qfile=null
                        var opt = document.getElementById("option");
                        opt.style.display = "block";
                      
                        var opc = document.getElementById("c");
                        opc.style.display = "none";
                        var opd = document.getElementById("d");
                        opd.style.display = "none";
                        var opd = document.getElementById("e");
                        opd.style.display = "none";
                        
                    });
                }//ends if condition of validateFileTypeOpt05()
                else{
                    if(this.ext_flag5 == true){
                        this.showSnackbar("#b71c1c", "Option 5 Image file should not exceed 200kb size!"); // show snackbar on error
                    } 
                    else{
                        this.ext_flag5 == false
                        this.showSnackbar("#b71c1c", " For Option 5, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
                    }
                }
            }//ends if condition of validateFileTypeOpt04()
            else{
                if(this.ext_flag4 == true){
                    this.showSnackbar("#b71c1c", "Option 4 Image file should not exceed 200kb size!"); // show snackbar on error
                } 
                else{
                    this.ext_flag4 == false
                    this.showSnackbar("#b71c1c", " For Option 4, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
                }
            }
            }//ends if condition of validateFileTypeOpt03()
            else{
                if(this.ext_flag3 == true){
                    this.showSnackbar("#b71c1c", "Option 3 Image file should not exceed 200kb size!"); // show snackbar on error
                } 
                else{
                    this.ext_flag3 == false
                    this.showSnackbar("#b71c1c", " For Option 3, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
                }
            }
        }////ends if condition of validateFileTypeOpt02()
            else{
            if(this.ext_flag2 == true){
                this.showSnackbar("#b71c1c", "Option 2 Image file should not exceed 200kb size!"); // show snackbar on error
            } 
            else{
                this.ext_flag2 == false
                this.showSnackbar("#b71c1c", " For Option 2, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
            }
        }
    }//ends if condition of validateFileTypeOpt01() 
    else{
        if(this.ext_flag1 == true){
            this.showSnackbar("#b71c1c", "Option 1 Image file should not exceed 200kb size!"); // show snackbar on error
        } 
        else{
            this.ext_flag1 == false
            this.showSnackbar("#b71c1c", " For Option 1, please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
        }
    }
    }//ends if condition of validateFile()
    else{
        if(this.ext_flag == true){
            this.showSnackbar("#b71c1c", "Question Image file should not exceed 200kb size!"); // show snackbar on error
        } 
        else{
            this.ext_flag == false
            this.showSnackbar("#b71c1c", "For Question please upload only image file! (.JPEG / .JPG)"); // show snackbar on error 
        }
    }
},
refresh()
{
            this.option_01 = null;
            this.option_02 = null;
            this.option_03 = null;
            this.option_04 = null;
            this.option_05 = null;
},
            isValidated() {
                if (this.editedItem.unit && this.editedItem.difficultylevel) {
                    return true;
                } else {
                    if (!this.editedItem.unit) {
                        this.errorMsg.unit = true;
                    }
                    if (!this.editedItem.adifficultylevely) {
                        this.errorMsg.difficultylevel = true;
                    }

                    return false;
                }
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .bottom {
        border: 2px solid rgb(150, 211, 223) !important;
        border-radius: 10px;
        padding: 5px;
        margin: 0.5rem !important;
        width: auto;
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .card-text{
        color: hsla(190, 99%, 30%, 1) !important;
    }
    .spancolor{
         color: hsla(190, 99%, 30%, 1) !important;
    }
    .spancolor2
    {
         color: #C62828 !important;
    }
    .radiospace {
        margin: 0.5rem !important;
        padding: 0%;
    }
    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
     .btn-submit-align {
        float: left;
        margin: 1rem !important;
    }
</style>
